import { validateRecipientClientBusiness } from './validateRecipientClientBusiness';
export const hasNewDataShape = (param)=>{
    let { primary, reviewers, contacts } = param;
    if (primary == null) return false;
    if (reviewers.length === 0) return false;
    const primaryEmail = primary.email().toLowerCase();
    const seenEmails = new Set();
    return reviewers.every((reviewer)=>{
        var _reviewer_email;
        const reviewerEmail = ((_reviewer_email = reviewer.email) !== null && _reviewer_email !== void 0 ? _reviewer_email : '').toLowerCase();
        if (reviewerEmail.length === 0) return false;
        if (reviewerEmail === primaryEmail) return false;
        if (seenEmails.has(reviewerEmail)) return false;
        seenEmails.add(reviewerEmail);
        const contact = contacts.find((c)=>c.email().toLowerCase() === reviewerEmail);
        if (contact == null) return false;
        if (contact.id() === primary.id()) return false;
        return validateRecipientClientBusiness({
            primary,
            recipient: contact
        }).valid;
    });
};
